import type { FC } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';

interface ProgressButtonProps {
  text: string;
  loading: boolean;
  loadingText: string;
  disabled?: boolean;
  variant?: 'text' | 'outlined' | 'contained';
  color?: 'inherit' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  type?: 'button' | 'reset' | 'submit';
  fullWidth?: boolean;
  size: 'small' | 'medium' | 'large';
  other?: any;
  sx?: any;
  onClick?: any;
  startIcon?: any;
}

const ProgressButton: FC<ProgressButtonProps> = (props) => {
  const { text, loading, loadingText, onClick, startIcon, ...other } = props;
  return (
    <Button onClick={onClick} startIcon={startIcon} {...other}>
      {loading ? (
        <Box alignItems="center" display="flex" justifyContent="center">
          <CircularProgress size={16} />
          <Typography sx={{ ml: 2 }} variant="body2">
            {loadingText}
          </Typography>
        </Box>
      ) : (
        <Typography variant="body2">{text}</Typography>
      )}
    </Button>
  );
};

ProgressButton.defaultProps = {
  loading: false,
  loadingText: 'Loading...',
  size: 'medium',
};

export default ProgressButton;
